import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormBuilder, Validators, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { HorseDiscipline } from 'src/app/models/horse-disciplines.enum';
import { Customer } from 'src/app/models/customer.model';
import { Horse, HorseStatus } from 'src/app/models/horse.model';
import { APIServiceService } from 'src/app/api/apiservice.service';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { SharedUIModuleModule } from 'src/app/shared/shared-uimodule/shared-uimodule.module';
import { ModalService } from 'src/app/services/modal.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ubc-new-horse-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedUIModuleModule
  ],
  templateUrl: './new-horse-form.component.html',
  styleUrls: ['./new-horse-form.component.scss']
})
export class NewHorseFormComponent implements OnInit {

  @Input() customer: Customer;
  @Output() horseCreated = new EventEmitter();
  @Output() cancelled = new EventEmitter();

  public horseStatuses = Object.values(HorseStatus) as HorseStatus[];

  createHorseForm: UntypedFormGroup;
  disciplines = Object.values(HorseDiscipline);

  constructor(
    private apiService: APIServiceService, 
    private fb: FormBuilder,
    public modalService: ModalService
  ) {}

  ngOnInit() {
    console.log("Horse form init ", this.modalService.horse)
    const disciplineControls = {};
    for (const discipline of this.disciplines) {
      disciplineControls[discipline] = new FormControl(false);
    }

    this.createHorseForm = this.fb.group({
      name: [this.modalService.horse?.name || "", Validators.required],
      height: [this.modalService.horse?.height || ""],
      age: [this.modalService.horse?.age || ""],
      breed: [this.modalService.horse?.breed || ""],
      sex: [this.modalService.horse?.sex || ""],
      isAffiliated: [this.modalService.horse?.isAffiliated || ""],
      colour: [this.modalService.horse?.colour || ""],
      disciplines: this.fb.group(disciplineControls),
      notes: [this.modalService.horse?.notes || ""],
      status: [this.modalService.horse?.status || HorseStatus.CURRENT]
    });

   
  }

 

  async createHorseSubmitted() {
    const fValues = {...this.createHorseForm.value};
    fValues.age = parseInt(fValues.age, 10);
    const horse = new Horse().deserialize(fValues);
    horse.customerId = this.customer.id;
    horse.disciplines = Object.keys(horse.disciplines).filter((key) => { return horse.disciplines[key] }).map((key) => { return key.replace(" ", "").toUpperCase() }) as HorseDiscipline[]
       

    console.log(fValues)

    if(this.modalService.horse){
      horse.id = this.modalService.horse.id
      try {
      const response = await this.apiService.horses.update(horse)
      console.log(response)

      const newHorse = response.data
        this.horseCreated.emit(newHorse);
        this.createHorseForm.reset();
        this.modalService.broadcastEvent({ type: 'CUSTOMER', action: 'horses_updated', newHorse })
        
      return
      } catch(e){
        throw e
      }
    } 

    this.apiService.horses.create(horse)
    .then((response) => {
     
      if (response.success) {
        const newHorse = response.data
        this.horseCreated.emit(newHorse);
        this.createHorseForm.reset();
        this.modalService.broadcastEvent({ type: 'CUSTOMER', action: 'horses_updated', newHorse })
       
      }
    })
    .catch((err) => { console.log(err) });
  }

  cancelCreateHorse() {
    this.cancelled.emit(null);
  }

  
}
